module.exports = __webpack_public_path__ + "img/chadle_adv_07.8d8cc5f1.png";